import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { useAuthStore } from './stores/auth';
import './styles/design-system.scss';
import '@vueform/multiselect/themes/default.css';
import 'flatpickr/dist/flatpickr.min.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');

const auth = useAuthStore();
void auth.restoreSession();
